import { render, staticRenderFns } from "./tile.vue?vue&type=template&id=46d12b12&scoped=true&"
import script from "./tile.vue?vue&type=script&lang=js&"
export * from "./tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d12b12",
  null
  
)

export default component.exports